<script setup lang="ts">
withDefaults(
  defineProps<{
    progress: number
    bgColor?: string
    fgColor?: string
  }>(),
  {
    bgColor: "bg-gray-200",
    fgColor: "bg-rnxblue-200",
  },
)
</script>

<template>
  <div>
    <div class="h-full rounded-full" :class="bgColor">
      <div :class="fgColor" class="h-full rounded-full" :style="`width: ${progress}%`" />
    </div>
  </div>
</template>
